import './team-member-card.scss';
